import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "./msalConfig.js";
import { msalConfigB2C } from "./msalConfigB2C.js";


export const msalInstanceAzureAD = new PublicClientApplication(msalConfig); // Azure AD
await msalInstanceAzureAD.initialize(); // Ensure the instance is initialized
export const msalInstanceAzureADB2C = new PublicClientApplication(msalConfigB2C); // Azure AD B2C
await msalInstanceAzureADB2C.initialize(); // Ensure the instance is initialized
